import React, { useEffect, useState } from 'react';
import './GarageList.css'
import Swal from 'sweetalert2';
import { Link, useNavigate } from 'react-router-dom';
import Loading from '../loading/Loading'
import axios from 'axios';
import { format } from 'date-fns';

function GarageList({ garagesList, actions }) {
  const navigate = useNavigate();
  const [garages, setGarages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingText, setLoadingText] = useState('Loading Garages, Please Wait...')

  const showTime = format(new Date(), 'MMddyyyyHis');

  useEffect(() => {
    // const deleteGarage = (id) => {
    //   Swal.fire({
    //     title: 'Are you sure?',
    //     text: "You won't be able to revert this!",
    //     icon: 'warning',
    //     showCancelButton: true,
    //     confirmButtonColor: '#3085d6',
    //     cancelButtonColor: '#d33',
    //     confirmButtonText: 'Yes, delete it!'
    //   }).then(async (result) => {
    //     if (result.value) {
    //       const data = await axios.post(`${process.env.REACT_APP_API_URL}`, {
    //         action: 'DeleteGarage',
    //         id: id,
    //       })
    //         .then(response => {
    //           if (response.data.status === true) {
    //             Swal.fire(
    //               'Deleted!',
    //               'Your garage has been deleted.',
    //               'success'
    //             ).then(() => {
    //               window.location.reload();
    //             })

    //           } else {
    //             Swal.fire(
    //               'Error!',
    //               response.data.message,
    //               'error'
    //             )
    //           }
    //         })
    //         .catch(error => {
    //           Swal.fire(
    //             'Error!',
    //             "Error: " + error,
    //             'error'
    //           )
    //         });
    //     }
    //   })
    // };

    function approveFun(key, ToggleValue) {
      // const originalUserStatus = ToggleValue;
      Swal.fire({
        title: 'Are you sure?',
        text: `You want to ${ToggleValue ? 'disable' : 'enable'} this garage!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: `Yes, ${ToggleValue ? 'disable' : 'enable'} it!`
      }).then(async (result) => {
        if (result.value) {
          Swal.fire({
            title: 'Updating, please wait',
            html:
              '<div class="loadingio-spinner-rolling-w23e05eix9"><div class="ldio-ik6pzj2wupc"><div></div></div></div>',
            showConfirmButton: false,
            showCancelButton: false,
            focusConfirm: false,
          });
          axios.post(`${process.env.REACT_APP_API_URL}`, { action: 'UpdateGarageStatusByUser', status: !ToggleValue, id: key })
            .then(response => {
              Swal.fire(
                'success',
                response.data.message,
                'success'
              ).then(() =>
                navigate(0)
              )
            })
            .catch(error => {
              Swal.fire(
                'There were a problem',
                error ? 'Error fetching data:' + error : 'Please, try again or contact SAGE Parents',
                'error'
              )
              console.error('Error fetching data:', error);
            });

        }
      })
    }



    if (garagesList && Object.keys(garagesList).length) {
      const getGaragesComponents = (garage, element) => {
        return (
          <div key={garage} className='col-xl-4 col-lg-4 col-md-6 col-sm-6 position-relative'>
            <div className="sale-item">
              <Link to={`/garages-details/${element.id}`} className='garage' >
                <div className="garage__img">
                  <img className="garage__image"
                    style={{ transform: `rotate(${element.garagePicturesA[0] ? element.garagePicturesA[0] : 0}deg)` }}
                    src={`${element.garagePictures[0] ? `${process.env.REACT_APP_UPLOAD_URL + element.garagePictures[0]}?time=${showTime}` : './assets/Images/garage-placeholder.png'}`}
                    alt='garage'></img>
                </div>
                <div className="item-info">
                  <div className="specs-info">
                    <p className="garage__access"><label className="garage__label">Area : </label> {(element.length * element.width) || 0}</p>
                    <p className="garage__access"><label className="garage__label">Access : </label> {element.sideDoor ? 'Side Door' : 'Only Garage'}</p>
                    <p className="garage__door"><label className="garage__label">Door : </label> {element.doorOpener ? 'Has door opener' : 'Only main door'}</p>
                    <p className="garage__door"><label className="garage__label">Neighborhood : </label> {element.neighborhood}</p>
                    <p className="garage__door"><label className="garage__label">Address : </label> {element.address}, {element.city}</p>
                    <p className="garage__door"><label className="garage__label">Price : </label> {element.rentalRate}USD</p>

                  </div>
                </div>
              </Link>
              <div className='userStatusColumn'>

                {element.status === 2 ?
                  <p className="garage__price"><label className="garage__label">Disable by Admin </label></p>
                  :
                  // <p className="garage__price"><label className="garage__label">{element.status === 1 ? 'Enabled' : 'Disabled'}</label></p>
                  <><button
                    className={`btn btn-${element.status === 1 ? "primary" : "secondary"} p-1`}
                    onClick={() => approveFun(element.id, element.status === 1 ? true : false)} >
                    {element.status === 1 ? "Enabled" : "Disabled"}
                  </button>
                    {/* <ToggleSwitch
                    onlabel="Enabled"
                    offlabel="Disabled"
                    onClick={() => approveFun(element.id, element.status === 1 ? true : false)}
                    checked={element.status === 1 ? true : false} /> */}
                  </>
                }
              </div>
            </div>
            {/* {actions && actions.delete && <span
              style={{ right: '30px', top: '10px' }}
              className='fa fa-trash text-danger position-absolute' onClick={() => deleteGarage(element.id)}></span>} */}
          </div>
        );
      };

      async function getGarages(garagesList) {
        let garagesContainer = [];
        try {
          for (const garage in garagesList) {
            if (garagesList.hasOwnProperty(garage)) {
              const element = garagesList[garage];
              garagesContainer.push(getGaragesComponents(garage, element));
            }
          }
          return garagesContainer;
        } catch (err) {
          throw err;
        }
      }

      getGarages(garagesList).then(resp => {
        //console.log('Garages results', resp);
        setGarages(() => [
          resp
        ]);

        if (resp.length > 0) {
          setLoading(false);
        } else {

          setLoading(true);
          setLoadingText("Oops, no garages found");
        }
      });
    } else {
      setGarages(() => { });
      setLoading(() => false);
      // setLoadingText("Loading...");
    }
  }, [garagesList, actions])

  return (loading ?
    <Loading text={loadingText} />
    :
    <div className='row m-auto'>
      <li id='labels'>
        <span></span>
        <p>Area</p>
        <p>Access</p>
        <p>Door</p>
        <p>Description</p>
      </li>
      {garages ? garages : <span>There are no garages to show</span>}
    </div>
  )
}

export default GarageList